import { Outlet } from "react-router";

import TeacherPortalQuizStatistics from "./QuizStatistics";
import React from "react";

const TeacherPortalQuiz = ({ quizInformation }) => {
    return (
        <>
            <div className="w-full">
                <TeacherPortalQuizStatistics quizInformation={quizInformation} />
            </div>
            <Outlet />
        </>
    );
};

export default TeacherPortalQuiz;
